import React from "react";
import { Redirect, useHistory } from "react-router-dom";

import { removeAuthCookies } from "../../API/cookies";

export const LogoutContainer = () => {
  const history = useHistory();
  removeAuthCookies();
  return (
    <Redirect
      to={{
        pathname: "/login",
        state: { from: history.location.state ? history.location.state.from : "/" },
      }}
    />
  );
};

export default LogoutContainer;
